module.exports = __webpack_public_path__ + "img/producto.9c5e609b.png";